module.exports = __webpack_public_path__ + "img/pro_five_6.f19aca8e.jpg";